// extracted by css-extract-rspack-plugin
export default {"root":"StoreLink-module__root___nT01X","iconWrapper":"StoreLink-module__iconWrapper___a8YnT"};